<template>
    <div class="calendar-component" id="calendar-component">
        <div class="calendar-component__month">
            {{ title }}, {{ year }}
        </div>
        <div class="calendar-component__days-week">
            <div class="calendar-component__day">
                пн
            </div>
            <div class="calendar-component__day">
                вт
            </div>
            <div class="calendar-component__day">
                ср
            </div>
            <div class="calendar-component__day">
                чт
            </div>
            <div class="calendar-component__day">
                пт
            </div>
            <div class="calendar-component__day">
                сб
            </div>
            <div class="calendar-component__day"
                style="margin-right: 2px"
            >
                вс
            </div>
        </div>

        <div class="calendar-component__days">
            <app-calendar-one-element
                v-for="(item, index) in days"
                :key="index"
                :index="index"
                :value="item.day"
                :year="year"
                :month="month"
                :available="item.available"
                :times="item.time"
                :info="item"
                @clickDate="clickDate"
            />
        </div>
    </div>
</template>

<script>

    const AppCalendarOneElement = () => import('~/components/calendar-one-element.vue')

    export default {
        props: {
            title: {
                default: ''
            },
            month: {
                default: 1
            },
            days: {
                default: false
            },
            year: {
              default: ''
            }
        },
        methods: {
            async clickDate({day, month, times, info, year}) {

                this.$emit('clickDate')
                await this.$store.dispatch('date/setDay', {
                    day: day
                })

                await this.$store.dispatch('date/setDayInfo', {
                    info: info
                })

                await this.$store.dispatch('date/setMonth', {
                    month: month
                })

                await this.$store.dispatch('date/setYear', {
                  year: year
                })

                await this.$store.dispatch('date/generateName')

                await this.$store.dispatch('date/setTimes', {
                    times: times
                })
            }
        },
        components: {
            AppCalendarOneElement
        }
    }
</script>

<style lang="less">

    .calendar-component {
        width: 355px;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 60px;
    }

    .calendar-component__month {
        color: #FFFFFF;
        font-size: 18px;
        font-family: 'Montserrat-Bold';
    }

    .calendar-component__days-week {
        width: 90%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 12px;
        margin-right: 3px;
    }

    .calendar-component__day {
        color: #ACAFBE;
        font-size: 13px;
        line-height: 20px;
        font-family: 'Roboto-Light';
        text-transform: uppercase;
    }

    .calendar-component__days {
        min-width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

</style>